class MovingCircle {
  constructor(circle, velocityVector){
    this.circle = circle;
    this.velocityVector = velocityVector;
  }

  updatePosition = (velocityVector = this.velocityVector) => {
    const {circle} = this;
    circle.centerX += velocityVector.x;
    circle.centerY += velocityVector.y;
  };

  draw = (ctx) => {
    this.circle.draw(ctx);
  };
}

export default MovingCircle;



// WEBPACK FOOTER //
// ./src/classes/MovingCircle/index.js